import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { Navigation, Pagination } from "swiper/modules";

const images = [
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-1.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-2.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-3.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-4.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-5.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-6.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-7.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-8.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-9.png" },
  /*{ src: "templates/softland/assets/img/app-gallery2/app-gallery-10.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-11.png" },
  { src: "templates/softland/assets/img/app-gallery2/app-gallery-12.png" },*/
];

export default function GalleryLightbox() {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  return (
    <>
      <Swiper
        modules={[Navigation, Pagination]}

        spaceBetween={40}
        slidesPerView={6}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 6 },
        }}
      >
        {images.map((img, i) => (
          <SwiperSlide key={img.src}>
            <img
              src={img.src}
              alt=""
              className="img-fluid"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIndex(i);
                setOpen(true);
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={images}
        index={index}
        on={{ view: ({ index }) => setIndex(index) }}
      />
    </>
  );
} 